<div class="container" style="display: flex; flex-direction: column; height: 100%;">

  <div class="row justify-content-center" style="margin-top: 20px;">

    <div class="col">
      <img src="../../assets/images/noaa-emblem-rgb-withspace-2022.png" class="center" height="130" width="130" />
    </div>

    <div class="col">
      <img src="../../assets/images/PSMFCLogo.png" class="center" height="130" width="130" />
    </div>

  </div>

  <br>

  <h1 class="display-6" align="center" style="font-weight:bolder; font-size: 33px;">NOAA Fisheries West Coast Logbook</h1>
  <b align="center">Ver. 3.1.3</b>

  <div class="row justify-content-center" style="margin-bottom: 5px;">
    <div class="col">
      <img src="../../assets/images/FishVueFloat FullColour Horizontal.png" class="center" style="height: auto; max-width: 100%; width: 225px;" />
    </div>
  </div>


  <form [formGroup]="loginForm" style="margin-right: 20px; margin-left: 20px;">

    <!-- Username field -->
    <div class="row">

      <mat-form-field appearance="outline">
        <mat-label>Username</mat-label>
        <input matInput
               required
               formControlName="username"
               (keyup.enter)="onLogin()">
        <mat-error *ngIf="loginForm.invalid">Required</mat-error>
      </mat-form-field>

    </div>

    <!-- Password field -->
    <div class="row">

      <mat-form-field appearance="outline">
        <mat-label>Password</mat-label>
        <input matInput
               required
               formControlName="password"
               [type]="hide ? 'password' : 'text'"
               (keyup.enter)="onLogin()">
        <button mat-icon-button
                matSuffix
                type="button"
                (click)="hide = !hide">
          <mat-icon>
            {{hide ? 'visibility_off' : 'visibility'}}
          </mat-icon>
        </button>
        <mat-error *ngIf="loginForm.invalid">Required</mat-error>
      </mat-form-field>

    </div>

  </form>

  <div class="container" style="display: flex; flex-direction: row; justify-content: flex-end;">
    <p style="color: #0d6efd; text-decoration: underline; font-size: 16px;" (click)="forgotPassword()">Forgot username or password?</p>
  </div>


  <br>

  <!-- Log in button -->
  <div class="row" style="margin-right: 20px; margin-left: 20px;">
    <button *ngIf="!sending" mat-stroked-button
            class="color-button-blue"
            type="submit"
            (click)="onLogin()">     
      <span>
        Log in
      </span>
    </button>
    <mat-progress-bar *ngIf="sending" mode="buffer"></mat-progress-bar>
  </div>
  <br>

  <div class="row justify-content-center" align="center" style="margin-top: auto; margin-bottom: 0px; padding-bottom: 5px;">
    <p style="font-size:medium; font-weight: bold; margin-bottom: 0px;">New to FishVue FLOAT? <a routerLink="/sign_up" routerLinkActive="active" ariaCurrentWhenActive="page">Sign Up</a></p>
  </div>

  <div class="row justify-content-center" align="center" style="padding-bottom: 5px;">
    <span style="font-style:italic;">Need help? Contact <b>fedelog&#64;psmfc.org</b></span>
  </div>

  <div class="row justify-content-center" align="center" style="padding-bottom: 5px;">
    <span style="font-size: smaller;">OMB Control Rule #0648-0804</span>
  </div>

</div>
